import { getCurrentSession } from '@auth/services/getCurrentSession';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { userLoggedIn } from '../user/reducer';
import { type Credentials } from './types';

const login = createAsyncThunk<Credentials>(
  'Session/Login',
  async (_, thunkAPI) => {
    const currentSession = await getCurrentSession();

    thunkAPI.dispatch(
      userLoggedIn({
        username: currentSession.username,
        email: currentSession.email,
        name: currentSession.name,
        picture: currentSession.picture,
        roles: currentSession.roles,
        id: currentSession.id,
      }),
    );

    return {
      accessToken: currentSession.accessToken,
      idToken: currentSession.idToken,
    };
  },
);

export { login };
